/**
 * Detect fn
 */
export default () => 'description' in self.Symbol.prototype
